import React, { useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";

function DeviceList({ token, devices, setDevices, setSelectedDevice, setSelectedDeviceName, setOpenModal, logout, showMessage, serverUrl }) {
  const { t } = useTranslation();

  const getDevices = () => {
    axios.get(`${serverUrl}/devices`, { headers: { Authorization: token } })
      .then((res) => setDevices(res.data.devices))
      .catch(() => showMessage(t("loadDevicesFailed")));
  };

  useEffect(() => {
    if (token) getDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]); // auto-load devices when token is set

  const displayDevice = (device) => {
    setSelectedDevice(device.id);
    setSelectedDeviceName(device.device_name);
    setOpenModal(true);
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" mt={4}>
        <Typography variant="h6">{t("yourDevices")}</Typography>
        <Button onClick={logout} color="error">{t("logout")}</Button>
      </Box>
      <Button variant="outlined" onClick={getDevices} sx={{ mt: 2 }}>{t("loadDevices")}</Button>
      <List>
        {devices.map((device, index) => {
          const blockReason = device.block_reason || null;
          const showBlockedChip = Boolean(device.is_blocked);
          const blockedChipLabel =
            blockReason === "too_many_retries"
              ? t("blockedTooManyRetriesChip")
              : t("blockedByAdminChip");
          const blockedChipColor =
            blockReason === "too_many_retries" ? "warning" : "error";
          return (
            <ListItem
              key={device.id}
              disablePadding
              divider={index !== devices.length - 1}
            >
              <ListItemButton onClick={() => displayDevice(device)}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                  gap={1}
                >
                  <ListItemText
                    primary={(device.device_name || t("unknown")).toString()}
                  />
                  {showBlockedChip && (
                    <Chip
                      size="small"
                      color={blockedChipColor}
                      label={blockedChipLabel}
                    />
                  )}
                </Box>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}

export default DeviceList;
